import { render, staticRenderFns } from "./Perifericos.vue?vue&type=template&id=211e2df5"
import script from "./Perifericos.vue?vue&type=script&lang=js"
export * from "./Perifericos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports